<template>
  <el-form :model="form" :rules="rules" ref="editForm" label-width="100px">
    <el-form-item label="ID" prop="id">
      <el-input v-model="form.id" disabled></el-input>
    </el-form-item>

    <el-form-item label="姓名" prop="name">
      <el-input v-model="form.name" placeholder="请输入姓名"></el-input>
    </el-form-item>

    <el-form-item label="电话" prop="tel">
      <el-input v-model="form.tel" placeholder="请输入电话"></el-input>
    </el-form-item>

    <el-form-item label="地址" prop="address">
      <el-input
        v-model="form.address"
        type="textarea"
        :rows="2"
        placeholder="请输入地址">
      </el-input>
    </el-form-item>

    <el-form-item label="URL" prop="url">
      <el-input v-model="form.url" placeholder="请输入URL"></el-input>
    </el-form-item>

    <el-form-item>
      <el-button type="primary" @click="submitForm">保存</el-button>
      <el-button @click="cancel">取消</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  props: {
    rowData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      form: {
        id: '',
        name: '',
        tel: '',
        address: '',
        url: '',
        clientIdentifier: 'bqxt'
      },
      rules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
          { min: 2, max: 20, message: '长度在2到20个字符', trigger: 'blur' }
        ],
        tel: [
          { required: true, message: '请输入电话', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
        ],
        address: [
          { required: true, message: '请输入地址', trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
    rowData: {
      immediate: true,
      handler(val) {
        if (val) {
          this.form = { ...val }
        }
      }
    }
  },
  methods: {
    submitForm() {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.$emit('submit', this.form)
        }
      })
    },
    cancel() {
      this.$emit('cancel')
    }
  }
}
</script>

<style scoped>
.el-form {
  padding: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/kehu/vivoRegistration/components/Edit.vue